import {
    getOrderPaymentDetail,
    getWechatpayUrl,
    getWechatQrcode,
    getClientPaymentDetail,
    getOpenID,
    getAlipayUrl,
    newWechatJsapiPayment} from "@/api/pay";

// 支付类型枚举
export const PaymentType = {
    ORDER_PAY: 'orderpay',
    CLIENT_PAY: 'clientpay'
};

const state = {
    appId: '',
    paymentType: ''
};

const mutations = {
    SET_APP_ID(state, appId) {
        state.appId = appId;
    },
    SET_PAYMENT_TYPE(state, paymentType) {
        state.paymentType = paymentType;
    }
};

const actions = {
    
    getclientpaymentdetail(_,data){
        return new Promise((resolve, reject) => {
            getClientPaymentDetail(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getorderpaymentdetail(_,data){
        return new Promise((resolve, reject) => {
            getOrderPaymentDetail(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getwechatqrcode(_,data){
        return new Promise((resolve, reject) => {
            getWechatQrcode(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getalipayurl(_,data){
        return new Promise((resolve, reject) => {
            getAlipayUrl(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getwechatpayurl(_,data){
        return new Promise((resolve, reject) => {
            getWechatpayUrl(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getopenid(_,data){
        return new Promise((resolve, reject) => {
            getOpenID(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    newwechatjsapipayment(_,data){
        return new Promise((resolve, reject) => {
            newWechatJsapiPayment(data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
